import { clsx } from 'clsx'
import { type FC } from 'react'

import { ProductSellerPromotionFlag } from '../../../../product'
import { productSearchAlgoliaAccessorGetBestOfferSellerPromotion } from '../../../model/productSearchAlgoliaAccessor/productSearchAlgoliaAccessorGetBestOfferSellerPromotion'
import { useProductSearchResultItemContext } from '../ProductSearchResultItemContext/productSearchResultItemContext'

import { ProductSearchResultItemGenericLabel } from './ProductSearchResultItemGenericLabel'

type ProductSearchResultItemSellerPromotionLabelProps = { className?: string }

export const ProductSearchResultItemSellerPromotionLabel: FC<
  ProductSearchResultItemSellerPromotionLabelProps
> = ({ className }) => {
  const { algoliaRecord } = useProductSearchResultItemContext()

  const sellerPromotion =
    productSearchAlgoliaAccessorGetBestOfferSellerPromotion(algoliaRecord)

  if (!sellerPromotion) {
    return null
  }

  return (
    <ProductSearchResultItemGenericLabel
      className={clsx('border-none bg-light-tertiary', className)}
      data-qa-id="serp-has-best-offer-seller-promotion-label"
    >
      <ProductSellerPromotionFlag sellerPromotion={sellerPromotion} />
    </ProductSearchResultItemGenericLabel>
  )
}
